import PagesLayout from "../../components/global/PagesLayout";
import PageHeader from "../../components/global/PageHeader";
import Breadcrumbs from "../../components/global/Breadcrumbs";
import Content from "../../components/articleDetails/Content";

const ArticleDetails = () => {
  return (
    <PagesLayout>
      <PageHeader title="Longer Article Title Should Definitely Go Here" />
      <Breadcrumbs title="Longer Article Title Should Definitely Go Here" />
      <Content />
      <Breadcrumbs title="Longer Article Title Should Definitely Go Here" />
    </PagesLayout>
  );
};

export default ArticleDetails;
